import React from 'react';
import { project_emptyMessage } from '@paraglide/messages';
import ProjectCard from '../ProjectCard/ProjectCard';
/**
 * 프로젝트 목록 컴포넌트
 * 
 * 프로젝트 카드 목록을 표시합니다.
 */ var ProjectList = function(param) {
    var projects = param.projects, emptyMessage = param.emptyMessage, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, onView = param.onView, onShare = param.onShare, // 아래 핸들러들은 ProjectCard 로직에 따라 전달 여부 결정
    onEdit = param.onEdit, onDelete = param.onDelete, onDuplicate = param.onDuplicate, onReport = param.onReport;
    if (projects.length === 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "p-12 text-center ".concat(className)
        }, /*#__PURE__*/ React.createElement("p", {
            className: "text-gray-500 dark:text-gray-400"
        }, emptyMessage || project_emptyMessage()));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "divide-y divide-gray-200 dark:divide-gray-800 ".concat(className)
    }, projects.map(function(project) {
        return /*#__PURE__*/ React.createElement(ProjectCard, {
            key: project.id,
            project: project,
            // canManage, canReport 등은 ProjectCard가 내부적으로 결정
            // 필요한 핸들러만 전달
            onViewDetails: function() {
                return onView && onView(project.id);
            },
            onShare: function() {
                return onShare && onShare(project.id);
            },
            // 아래 핸들러들은 ProjectCard 구현 방식에 따라 전달 필요
            onEdit: function() {
                return onEdit && onEdit(project.id);
            },
            onDelete: function() {
                return onDelete && onDelete(project.id);
            },
            onDuplicate: function() {
                return onDuplicate && onDuplicate(project.id);
            },
            onReport: function() {
                return onReport && onReport(project.id);
            }
        });
    }));
};
export default ProjectList;
